import React from 'react';
import { Sprite } from '../sprite';

export type FilterSelectOption = {
  value: string
  label: string
}

interface Props {
  currentValue: string
  options: FilterSelectOption[]
  onChange: {(value: string): void}
  placeholder?: string
  icon?: React.ReactNode
}

export const FilterSelect: React.FC<Props> = ({
  currentValue,
  options,
  onChange,
  placeholder,
  icon,
}) => (
  <div className="relative">
    <select
      value={currentValue}
      onChange={(event) => onChange(event.currentTarget.value)}
      className="appearance-none shadow-[0px_1px_1px_rgba(0,0,0,0.08)] rounded-[8px] bg-white min-w-[72px] h-[40px] px-3 py-2 w-full bg-white pr-[26px]"
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value.toString()}>{option.label}</option>
      ))}
    </select>
    <div className="absolute h-full top-0 right-0 flex flex-col justify-center pr-[7px] pointer-events-none">
      {icon}
    </div>
  </div>
);

FilterSelect.defaultProps = {
  placeholder: undefined,
  icon: (
    <Sprite
      name="icon-selector"
      className="w-[8px] h-[14px] text-gray fill-gray"
    />
  ),
};
